import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalcfgService {
  fullRoleObj: any;
  userID:any;
  constructor() { }

  _userActionOccured: Subject<void> = new Subject();
  get userActionOccured(): Observable<void> { return this._userActionOccured.asObservable() };

  notifyUserAction() {
    this._userActionOccured.next();
  }

  loginUser() {
   // console.log('user login');
  }

  logOutUser() {
     alert();
    //console.log('user logout');
  }
  setFullRoleObj(user: any) {
    this.fullRoleObj = user;
  }

  getFullRoleObj() {
    return this.fullRoleObj;
  }


  setUserId(user: any) {
    this.userID = user;
  }

  getUserId() {
    return this.userID;
  }
  menuPages = [
    {
      name: 'Receiver',
      path: '/create-challan',

      isSelected: false,
      dropDown: [
        {
          name: 'Create Batch',
          isSelected: false,
          navigate: true


        }, {
          name: 'List of Challans',
          isSelected: false,
          path: '/challan-list'

        }, {
          name: 'Onboard Container',
          isSelected: false,
          path: '/onboard-container'

        }
      ]
    }
  ]
}
